export default __webpack_public_path__ + "static/media/live_war.c618e51d.gif";